const REPORT_SOURCE = {
  brands: 'brands',
  subBrands: 'subBrands',
};

export default REPORT_SOURCE;
